"use client";

import React from "react";
import { CircleAlert, PackageX } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { EcommerceTermsProvider, useEcommerceTerms } from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
import { WP_Term_Query } from "@/integrations/wordpress/wp_term_query";
function CategoryGridConsumer() {
  const {
    terms,
    loading,
    error,
    refetch
  } = useEcommerceTerms();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
        {[...Array(8)].map((_, i) => <div key={i} data-index={i} className="space-y-4 animate-pulse">
            <AspectRatio ratio={1}>
              <div className="w-full h-full bg-muted rounded-lg" />
            </AspectRatio>
            <div className="h-4 bg-muted rounded w-3/4 mx-auto" />
          </div>)}
      </div>;
  }
  if (error) {
    return <Alert variant="destructive" className="my-8">
        <CircleAlert className="h-4 w-4" />
        <AlertTitle>Error</AlertTitle>
        <AlertDescription className="flex flex-col sm:flex-row sm:items-center gap-4 mt-2">
          <span>No se pudieron cargar las categorías. Por favor, intenta de nuevo.</span>
          <Button variant="outline" size="sm" onClick={refetch} className="w-fit">
            Reintentar
          </Button>
        </AlertDescription>
      </Alert>;
  }
  if (terms.length === 0) {
    return <div className="flex flex-col items-center justify-center py-20 text-center border border-border border-dashed rounded-xl bg-muted/10">
        <PackageX className="h-16 w-16 text-muted-foreground mb-4 opacity-50" />
        <h3 className="text-2xl font-default font-semibold text-foreground mb-2">
          No hay categorías disponibles
        </h3>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-x-8 gap-y-12 sm:grid-cols-2 lg:grid-cols-4">
      {terms.map((term, i) => <Link key={term.id} to={term.link || "#"} className="group block">
          <Card data-index={i} className="border-none bg-transparent p-0 gap-0">
            <div className="overflow-hidden rounded-lg border border-gray-200 bg-white p-1 transition-all duration-300 group-hover:shadow-md group-hover:border-primary/20">
              <AspectRatio ratio={1}>
                {term.image_url ? <img src={term.image_url} alt={term.name} className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-105" loading="lazy" /> : <div className="w-full h-full flex items-center justify-center bg-muted text-muted-foreground">
                    <PackageX className="h-10 w-10 opacity-30" />
                  </div>}
              </AspectRatio>
            </div>
            <h3 className="mt-4 text-center text-lg font-default font-medium text-gray-700 group-hover:text-primary transition-colors">
              {term.name}
            </h3>
          </Card>
        </Link>)}
    </div>;
}
export default function ProductosDisponibles() {
  const wp_term_query_params = {
    taxonomy: "product_cat",
    per_page: 12,
    order: "asc",
    orderby: "name"
  };
  const wp_term_query = new WP_Term_Query(wp_term_query_params);
  return <section id="productos-disponibles" className="bg-background">
      {}
      

      
    </section>;
}